import React from 'react'
import { provideState, injectState, softUpdate } from 'freactal'
import { Card } from 'react-mdl'
import Button from '../../../components/Button'
import Editor from '../../../components/Editor'
import SavingIndicator from '../../../components/SavingIndicator'
import {
  deserializeContentSection,
  serializeContentSection,
} from '../../../lib'
import app from '../../../feathers'
import TextListEditor from '../../components/TextListEditor'

const units = app.service('units')

const withState = provideState({
  initialState: ({ summativePracticalAssessment }) => {
    const {
      assessmentPlan: {
        objectivesOutcomesOrRequirements,
        spaceOrLocationRequirements,
        environmentalConsiderations,
        taskOrSiteSpecificRequirements,
        requiredResources,
      },
    } = summativePracticalAssessment
    return {
      objectivesOutcomesOrRequirements: deserializeContentSection(
        objectivesOutcomesOrRequirements,
      ),
      spaceOrLocationRequirements: deserializeContentSection(
        spaceOrLocationRequirements,
      ),
      environmentalConsiderations: deserializeContentSection(
        environmentalConsiderations,
      ),
      taskOrSiteSpecificRequirements: deserializeContentSection(
        taskOrSiteSpecificRequirements,
      ),
      requiredResources,
    }
  },
  effects: {
    setFlag: softUpdate((_, key, val) => ({
      [key]: val,
    })),
    handleChangeObjectivesOutcomesOrRequirements: softUpdate((_, val) => ({
      objectivesOutcomesOrRequirements: val,
    })),
    handleChangeSpaceOrLocationRequirements: softUpdate((_, val) => ({
      spaceOrLocationRequirements: val,
    })),
    handleChangeEnvironmentalConsiderations: softUpdate((_, val) => ({
      environmentalConsiderations: val,
    })),
    handleChangeTaskOrSiteSpecificRequirements: softUpdate((_, val) => ({
      taskOrSiteSpecificRequirements: val,
    })),
    handleChangeRequiredResources: softUpdate((_, requiredResources) => ({
      requiredResources,
    })),
    handleSave: async (
      { setFlag },
      {
        unitId,
        summativePracticalAssessmentIndex,
        objectivesOutcomesOrRequirements,
        spaceOrLocationRequirements,
        environmentalConsiderations,
        taskOrSiteSpecificRequirements,
        requiredResources,
      },
    ) => {
      if (unitId == null || summativePracticalAssessmentIndex == null) {
        return alert(
          'There was an issue identifying the Summative Practical Assessment.',
        )
      }
      setFlag('saving', true)
      const updatedAssessmentPlan = {
        objectivesOutcomesOrRequirements: serializeContentSection(
          objectivesOutcomesOrRequirements,
        ),
        spaceOrLocationRequirements: serializeContentSection(
          spaceOrLocationRequirements,
        ),
        environmentalConsiderations: serializeContentSection(
          environmentalConsiderations,
        ),
        taskOrSiteSpecificRequirements: serializeContentSection(
          taskOrSiteSpecificRequirements,
        ),
        requiredResources,
      }
      await units.patch(unitId, {
        [`summativePracticalAssessments.${summativePracticalAssessmentIndex}.assessmentPlan`]: updatedAssessmentPlan,
      })
      setFlag('saving', false)
    },
  },
})

function Content({
  summativePracticalAssessmentIndex,
  state: {
    unit: { _id: unitId },
    objectivesOutcomesOrRequirements,
    spaceOrLocationRequirements,
    environmentalConsiderations,
    taskOrSiteSpecificRequirements,
    requiredResources,
    saving,
  },
  effects: {
    handleChangeObjectivesOutcomesOrRequirements,
    handleChangeSpaceOrLocationRequirements,
    handleChangeEnvironmentalConsiderations,
    handleChangeTaskOrSiteSpecificRequirements,
    handleChangeRequiredResources,
    handleSave,
  },
}) {
  return (
    <Card shadow={0} style={{ padding: '1em', width: '100%' }}>
      <SavingIndicator saving={saving} />
      <h5>Objectives, Outcomes, or Requirements</h5>
      <Editor
        onChange={handleChangeObjectivesOutcomesOrRequirements}
        state={objectivesOutcomesOrRequirements}
      />
      <h5>Space or Location Requirements</h5>
      <Editor
        onChange={handleChangeSpaceOrLocationRequirements}
        state={spaceOrLocationRequirements}
      />
      <h5>Environmental Considerations</h5>
      <Editor
        onChange={handleChangeEnvironmentalConsiderations}
        state={environmentalConsiderations}
      />
      <h5>Task or Site-Specific Requirements</h5>
      <Editor
        onChange={handleChangeTaskOrSiteSpecificRequirements}
        state={taskOrSiteSpecificRequirements}
      />
      <h5>Equipment or Resources Required for Assessment</h5>
      <p>
        Add a subtask to the list by adding a single '#' at the beginning of the
        text. To add a subtask to a subtask, add two '#' characters at the
        beginning of the text ('##').
      </p>
      <TextListEditor
        textList={requiredResources}
        onChange={handleChangeRequiredResources}
      />
      <Button
        onClick={() =>
          handleSave({
            unitId,
            summativePracticalAssessmentIndex,
            objectivesOutcomesOrRequirements,
            spaceOrLocationRequirements,
            environmentalConsiderations,
            taskOrSiteSpecificRequirements,
            requiredResources,
          })}>
        Save
      </Button>
    </Card>
  )
}

export default withState(injectState(Content))



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/AssessmentPlan/Content.js